import { Autocomplete, Button, FormLabel, Grid, Popover, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AudioFileClient } from '../../api/server';
import GlobalAudioFiles from "../AudioFiles/GlobalAudioFiles";
import { ArrowDropDownCircleTwoTone } from "@mui/icons-material";
import { ExtendedClient } from "../../api/ExtendedClient";

export default function MarketingMessages(props) {

    const { audioIds, setAudioIds } = props;

    const globalInfo = useSelector((state) => state.globalInfo)
    const [defaultValue, setDefaultValue] = useState([]);
    const [audioFiles, setAudioFiles] = useState([]);

    useEffect(() => {

        const client1 = (new ExtendedClient(AudioFileClient)).getClient();


        client1.getGlobalAudioFiles(globalInfo.currentCompanyId).then(
            (data) => {
                setAudioFiles(data);
            }
        )

    }, [globalInfo])

    function getSelectedObjects(audioIds) {
        var result = [];

        audioIds.forEach(element => {
            var filtered = audioFiles.filter((x) => x.audioFileId === element);
            if (filtered.length > 0) {
                result.push({ audioFileId: filtered[0].audioFileId, name: filtered[0].name });
            }
        });

        return result;
    }

    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    useEffect(() => {
        if (!audioIds) return;
        if (audioFiles.length === 0) return;
        var selectedObjects = getSelectedObjects(audioIds);

        setDefaultValue(selectedObjects)
        // eslint-disable-next-line
    }, [audioFiles, audioIds])

    return (
        <div>
            <Grid container={true}>
                <Grid item xs={10}>
                    <Autocomplete
                        onChange={(event, value) => { setAudioIds((value.map((x) => { return x.audioFileId }))); }}
                        multiple
                        options={audioFiles.map((item) => { return { "audioFileId": item.audioFileId, "name": item.name, "path": item.path } })}
                        value={defaultValue}
                        getOptionLabel={(option) => option.name}
                        renderOption={(props, option) => {
                            return (
                                <div key={option.audioFileId}>
                                    <span {...props} key={option.audioFileId}>
                                        {option.name}
                                    </span>
                                </div>
                            );
                        }}
                        isOptionEqualToValue={(option, value) => option.audioFileId === value.audioFileId}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="standard"
                            />
                        )}
                    />
                </Grid>
                <Grid item>
                    &nbsp;
                    <Button variant={'outlined'} size='small' aria-describedby={id} onClick={handleClick}>
                        &nbsp;Preview &nbsp;<ArrowDropDownCircleTwoTone></ArrowDropDownCircleTwoTone>
                    </Button>

                </Grid>
            </Grid>

            <FormLabel>(These messages will play during call transfer)</FormLabel>
            <br></br>
            <Popover open={open}
                onClose={handleClose}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}>
                <GlobalAudioFiles></GlobalAudioFiles>
            </Popover>
        </div>
    )
}
